/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Dev_Backend_Restart_BodyInputs */

const en_mobile_dev_backend_restart_body = /** @type {(inputs: Mobile_Dev_Backend_Restart_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The app needs to restart to finish switching backends. You will be signed in again per backend.`)
};

const es_mobile_dev_backend_restart_body = /** @type {(inputs: Mobile_Dev_Backend_Restart_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La aplicación debe reiniciarse para terminar de cambiar de backend. Deberás iniciar sesión en cada backend por separado.`)
};

/**
* | output |
* | --- |
* | "The app needs to restart to finish switching backends. You will be signed in again per backend." |
*
* @param {Mobile_Dev_Backend_Restart_BodyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_dev_backend_restart_body = /** @type {((inputs?: Mobile_Dev_Backend_Restart_BodyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Dev_Backend_Restart_BodyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_dev_backend_restart_body(inputs)
	return en_mobile_dev_backend_restart_body(inputs)
});